export function getInitials(fullName: string) {
  const createInitials = fullName
    .split(' ')
    .map(word => word.slice(0, 1))
    .join('');

  return createInitials;
}
